/**
 * @param   {EditorState} editorState
 * @param   {String}      maybeActiveStyle
 * @returns {Boolean}
 */
export default function isInlineStyleActive(editorState, maybeActiveStyle) {
  return editorState.getCurrentInlineStyle().includes(maybeActiveStyle);
}
